"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var uuid_1 = require("uuid");
var GlobalState = /** @class */ (function () {
    /**
     * Initial state is *NOT* mutation-safe!
     */
    function GlobalState(initialState, stateWillUpdate, stateDidUpdate) {
        this._reactContext = React.createContext(null);
        this._state = initialState;
        this._refreshProviderInjectorCollection = {};
        this._stateWillUpdate = stateWillUpdate;
        this._stateDidUpdate = stateDidUpdate;
        this._componentsWithInjectedStateCollection = {};
    }
    Object.defineProperty(GlobalState.prototype, "stats", {
        get: function () {
            return {
                componentsInjectingProviderCount: Object.keys(this._refreshProviderInjectorCollection).length,
                componentsWithInjectedStateCount: Object.keys(this._componentsWithInjectedStateCollection).length
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalState.prototype, "state", {
        /**
         * State is *NOT* mutation-safe!
         */
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    GlobalState.prototype.withState = function (Component, stateKeys) {
        var globalState = this;
        var _a = this._reactContext, Consumer = _a.Consumer, Provider = _a.Provider;
        function ComponentWrapper(_a) {
            var componentRef = _a.componentRef, __gs_injectsProvider = _a.__gs_injectsProvider, __gs_providerInjectorState = _a.__gs_providerInjectorState, props = __rest(_a, ["componentRef", "__gs_injectsProvider", "__gs_providerInjectorState"]);
            var stateProps = stateKeys
                ? stateKeys.reduce(function (_state, key) {
                    var _a;
                    return (__assign(__assign({}, _state), (_a = {}, _a[key] = globalState._state[key], _a)));
                }, {})
                : globalState._state;
            // Ignoring since we're not enforcing the wrappeed component props type
            // @ts-ignore
            return (React.createElement(Component, __assign({}, stateProps, props, { __gs_providerInjectorState: __gs_providerInjectorState, __gs_injectsProvider: __gs_injectsProvider, ref: componentRef })));
        }
        var ProviderInjector = /** @class */ (function (_super) {
            __extends(ProviderInjector, _super);
            function ProviderInjector(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    providerId: (0, uuid_1.v4)(),
                    stateKey: 0
                };
                return _this;
            }
            ProviderInjector.prototype.componentDidMount = function () {
                var _this = this;
                globalState._refreshProviderInjectorCollection[this.state.providerId] = function () { return new Promise(function (resolve) {
                    // No need to ensure stateKey being always incremented correctly, we only need to ensure 
                    // React refreshes the component
                    _this.setState({ stateKey: _this.state.stateKey + 1 }, resolve);
                }); };
            };
            ProviderInjector.prototype.componentWillUnmount = function () {
                delete globalState._refreshProviderInjectorCollection[this.state.providerId];
            };
            ProviderInjector.prototype.render = function () {
                return (React.createElement(Provider, { value: this.state },
                    React.createElement(ComponentWrapper, __assign({}, this.props, { __gs_injectsProvider: true, __gs_providerInjectorState: this.state }))));
            };
            return ProviderInjector;
        }(React.Component));
        return React.forwardRef(function (props, ref) {
            React.useEffect(function () {
                var _a, _b;
                var componentId = (0, uuid_1.v4)();
                globalState._componentsWithInjectedStateCollection[componentId] = (_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : "AnonymousComponent";
                return function () {
                    delete globalState._componentsWithInjectedStateCollection[componentId];
                };
            }, []);
            return (React.createElement(Consumer, null, function (providerState) {
                if (providerState === null) {
                    // No provider has been injected above this component, so we need to inject one
                    return React.createElement(ProviderInjector, __assign({}, props, { componentRef: ref }));
                }
                return (React.createElement(ComponentWrapper, __assign({}, props, { componentRef: ref, __gs_injectsProvider: false, __gs_providerInjectorState: providerState })));
            }));
        });
    };
    /**
     * State and state updates are *NOT* mutation-safe!
     */
    GlobalState.prototype.updateState = function (stateUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            var prevState, nextState, refreshedComponentIds, refreshComponentId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prevState = this._state;
                        if (typeof stateUpdate === "function") {
                            nextState = stateUpdate(this._state);
                        }
                        else {
                            nextState = __assign(__assign({}, this._state), stateUpdate);
                        }
                        if (this._stateWillUpdate) {
                            nextState = this._stateWillUpdate(nextState);
                            if (!nextState) {
                                throw new Error("State will update hook must return next state");
                            }
                        }
                        this._state = nextState;
                        refreshedComponentIds = [];
                        _a.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 3];
                        refreshComponentId = Object.keys(this._refreshProviderInjectorCollection).find(function (id) { return !refreshedComponentIds.includes(id); });
                        if (!refreshComponentId) {
                            return [3 /*break*/, 3];
                        }
                        refreshedComponentIds.push(refreshComponentId);
                        return [4 /*yield*/, this._refreshProviderInjectorCollection[refreshComponentId]()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 3:
                        if (this._stateDidUpdate) {
                            this._stateDidUpdate(prevState);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return GlobalState;
}());
exports.default = GlobalState;
